
import { AnchorHTMLAttributes, forwardRef } from 'react';
import { Link } from '../UI/Link';
import { buttonBaseHOC } from './ButtonNext';

export const NavButton = buttonBaseHOC<
  HTMLAnchorElement,
  AnchorHTMLAttributes<HTMLAnchorElement>
>(
  forwardRef<HTMLAnchorElement, { disabled?: boolean; href?: string }>(
    ({ disabled, href, ...restOfProps }, ref) => (
      <Link ref={ref} to={(!disabled && href) || ''} {...restOfProps} />
    )
  )
);
